// Airport display helpers — the full mapping lives in @/data/airports.
// This module re-exports it and adds lightweight display helpers used in
// filter chips, tooltips and anywhere a human-readable airport label is needed.
import { AIRPORT_DB, FLAG_COUNTRY } from '@/data/airports'

export { AIRPORT_DB, FLAG_COUNTRY }

/**
 * Full readable label for filter chips:  "🇳🇱 Amsterdam (AMS)"
 * Falls back to the bare IATA code when the airport is not in AIRPORT_DB.
 */
export function getAirportLabel(iata) {
  const info = AIRPORT_DB[iata]
  if (!info) return iata
  return `${info.flag} ${info.city} (${iata})`
}

/**
 * Tooltip text for hover:  "Amsterdam, Netherlands"
 * Falls back to the IATA code when unknown.
 */
export function getAirportTooltip(iata) {
  const info = AIRPORT_DB[iata]
  if (!info) return iata
  const country = FLAG_COUNTRY[info.flag] ?? ''
  return country ? `${info.city}, ${country}` : info.city
}

/**
 * City name only, falling back to the IATA code.
 */
export function getAirportCity(iata) {
  return AIRPORT_DB[iata]?.city ?? iata
}
